export const domainsDataSelector = (state) => state.domains.data;
export const domainsCurrentSelector = (state) => state.domains.currentDomain;
export const domainsUser = (state) => state.domains.user;

export const getIsVisibleSetDataTypeModal = (state) =>
  state.domains.isVisibleSetDataTypeModal;
